import car from '../../images/car.png';
import bus from '../../images/bus.png';
import train from '../../images/train.png';
import bike from '../../images/bike.png';

export const ridesItems = [
    { id: 1, image: car, demand: 47, name: 'Car', capability: 4 },
    { id: 2, image: car, demand: 58, name: 'Car', capability: 6 },
    { id: 3, image: car, demand: 68, name: 'Car', capability: 8 },
    { id: 4, image: car, demand: 65, name: 'Car', capability: 7 },
    { id: 5, image: bus, demand: 175, name: 'Bus', capability: 25 },
    { id: 6, image: bus, demand: 189, name: 'Bus', capability: 30 },
    { id: 7, image: bus, demand: 200, name: 'Bus', capability: 35 },
    { id: 8, image: bus, demand: 220, name: 'Bus', capability: 45 },
    { id: 9, image: train, demand: 500, name: 'Train', capability: 125 },
    { id: 10, image: train, demand: 600, name: 'Train', capability: 130 },
    { id: 11, image: train, demand: 800, name: 'Train', capability: 145 },
    { id: 12, image: train, demand: 1200, name: 'Train', capability: 200 },
    { id: 13, image: bike, demand: 15, name: 'Bike', capability: 1 },
    { id: 14, image: bike, demand: 25, name: 'Bike', capability: 2 },
    { id: 15, image: bike, demand: 25, name: 'Bike', capability: 2 },
    { id: 16, image: bike, demand: 12, name: 'Bike', capability: 1 },
]